import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme } from './theme';
import Main from "./pages/Main";
import { AppProviders } from "./context/AppProviders";

import { SnackbarProvider } from 'notistack';

// Material Kit 2 PRO React routes
import routes from "./routes";

import ViewerPageWrapper from "./pages/ViewerPageWrapper.jsx"
import CesiumViewerWrapper from "./pages/CesiumViewerWrapper.jsx"
import PublicViewerWrapper from "./pages/PublicViewerWrapper.jsx"
import PublicCesiumViewer from "./viewer/PublicCesiumViewer.jsx"
import ShortUrlResolver from "./components/ShortUrlResolver.jsx"
import ThankYou from "./pages/ThankYou.jsx"

import "./locale/i18n";

export default function App() {
  const { pathname } = useLocation();

  const theme = createTheme();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
    });

  return (
    <AppProviders>
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3} autoHideDuration={5000}   anchorOrigin={{vertical: 'bottom',horizontal: 'center',}}>
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Main />} />
        <Route path="/viewer-page" element={<ViewerPageWrapper/>} />
        <Route path="/cesium-viewer-page" element={<CesiumViewerWrapper/>} />
        <Route path="/public/potree/:shareId" element={<PublicViewerWrapper/>} />
        <Route path="/public/thank-you" element={<ThankYou/>} />
        {/* Most specific routes first - with products AND transformations */}
        <Route path="/public/cesium/:assetId/:gaussianAssetId/products/:productsIds/t/:transformationsParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/products/:productsIds/t/:transformationsParam/:token" element={<PublicCesiumViewer/>} />
        {/* Routes with transformations (no products) */}
        <Route path="/public/cesium/:assetId/:gaussianAssetId/t/:transformationsParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/t/:transformationsParam/:token" element={<PublicCesiumViewer/>} />
        {/* Routes with products (no transformations) */}
        <Route path="/public/cesium/:assetId/:gaussianAssetId/products/:productsIds/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/products/:productsIds/:token" element={<PublicCesiumViewer/>} />
        {/* General routes (no products, no transformations) */}
        <Route path="/public/cesium/:assetId/:gaussianAssetId/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/:token" element={<PublicCesiumViewer/>} />
        {/* Deprecated: legacy routes with /z/:zTranslationParam — kept for existing share links */}
        <Route path="/public/cesium/:assetId/:gaussianAssetId/products/:productsIds/z/:zTranslationParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/products/:productsIds/z/:zTranslationParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/:gaussianAssetId/z/:zTranslationParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/public/cesium/:assetId/z/:zTranslationParam/:token" element={<PublicCesiumViewer/>} />
        <Route path="/:shortCode" element={<ShortUrlResolver />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </SnackbarProvider>
    </ThemeProvider> 
    </AppProviders>
  );
}
